import { render, staticRenderFns } from "./ScanLocalHistory.vue?vue&type=template&id=2a2de352&scoped=true"
import script from "./ScanLocalHistory.vue?vue&type=script&lang=js"
export * from "./ScanLocalHistory.vue?vue&type=script&lang=js"
import style0 from "./ScanLocalHistory.vue?vue&type=style&index=0&id=2a2de352&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../shieldgo-admin-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2de352",
  null
  
)

export default component.exports